import React, { Fragment, useState } from 'react';

import { FieldArray, Formik } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import CheckboxFormField from 'CommonComponents/CheckboxFormField';
import SectionTile from 'CommonComponents/SectionTile';
import TextFormField from 'CommonComponents/TextFormField';

import { useToast } from 'Hooks/useToast';

import TrashIcon from 'Assets/icons/trash.svg';

const DEFAULT_SEAT_KILLS_CATEGORY = { id: null, is_hold: false, name: '' };
const SeatKillCategories = Yup.object().shape({
    seat_kills_categories: Yup.array().of(
        Yup.object().shape({
            name: Yup.string().required('This value is required'),
            is_hold: Yup.boolean(),
        }),
    ),
});
export const SeatKillsCategories = (props) => {
    const [collapsed, setCollapsed] = useState(true);

    const toast = useToast();

    const onDelete = (categoryId) => {
        if (confirm($t('Are you sure you want to delete this category?'))) {
            const url = props.deleteUrl.replace('CATEGORY_ID', categoryId);

            axios
                .delete(url)
                .then(() => {
                    props.fetchCategories();
                    toast.success($t('Seat kills category deleted successfully'));
                })
                .catch(() => {
                    toast.error($t('Seat kills category deleted failed'));
                });
        }
    };

    return (
        <div className="tw-flex-auto tw-flex tw-flex-col tw-px-6 tw-py-6.5 tw-mb-3 tw-rounded-lg tw-bg-white tw-shadow-primary tw-space-y-7">
            <div className="tw-flex-initial">
                <SectionTile flat header={$t('Categories')} collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} visibly>
                    <div>
                        <Formik
                            enableReinitialize
                            initialValues={{
                                seat_kills_categories: props.categories?.map(({ id, name, is_hold }) => ({ id, name, is_hold })) || [],
                            }}
                            validationSchema={SeatKillCategories}
                            onSubmit={(values, actions) => {
                                axios
                                    .put(props.upsertUrl, { seat_kills_categories: values.seat_kills_categories })
                                    .then(() => {
                                        props.fetchCategories();
                                        toast.success($t('Seat kills categories updated successfully'));
                                    })
                                    .catch((e) => {
                                        actions.setErrors(e.response.data.errors);
                                        toast.error($t('Seat kills categories update failed'));
                                        actions.setSubmitting(false);
                                    });
                            }}
                        >
                            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                                <div>
                                    <FieldArray
                                        name="seat_kills_categories"
                                        render={(arrayHelpers) => (
                                            <Fragment>
                                                <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
                                                    <div className="tw-ml-auto">
                                                        <Button variant="primary" onClick={() => arrayHelpers.push(DEFAULT_SEAT_KILLS_CATEGORY)}>
                                                            {$t('Create New Category')}
                                                        </Button>
                                                    </div>
                                                </div>
                                                <div className="inbud-table_wrapper">
                                                    <table className="inbud-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="tw-w-20">{$t('Hold')}</th>
                                                                <th>{$t('Name')}</th>
                                                                <th className="tw-w-20">{$t('Actions')}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {values.seat_kills_categories?.length ? (
                                                                values.seat_kills_categories.map((seatKillCategory, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                <CheckboxFormField
                                                                                    type="checkbox"
                                                                                    name={`seat_kills_categories.${index}.is_hold`}
                                                                                    id={`seat_kills_categories${index}_is_hold`}
                                                                                ></CheckboxFormField>
                                                                            </td>
                                                                            <td>
                                                                                <TextFormField
                                                                                    hideLabel
                                                                                    name={`seat_kills_categories.${index}.name`}
                                                                                    placeholder={$t('Name')}
                                                                                ></TextFormField>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className="tw-text-red"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        const cat = values.seat_kills_categories[index];
                                                                                        if (!cat.id) {
                                                                                            arrayHelpers.remove(index);
                                                                                        } else {
                                                                                            onDelete(cat.id);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <TrashIcon className="tw-w-3 tw-h-3" />
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={100}>{$t('No seat kills categories added yet')}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Fragment>
                                        )}
                                    />
                                    <div className="tw-mt-6 tw-flex tw-justify-end">
                                        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                                            {$t('Save')}
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </Formik>
                    </div>
                </SectionTile>
            </div>
        </div>
    );
};
